/**
 * Footer Animation
 *
 * Add behaviors to stop and start footer graphic animation
 */

class FooterAnimation {
  constructor() {
    this.initialize();
  }

  initialize() {
    const controlButton = document.querySelector('.control-button');
    const pauseIcon = controlButton.querySelector('.dashicons-controls-pause');
    const playIcon = controlButton.querySelector('.dashicons-controls-play');
    const footerBgImg = document.querySelector('.footer-bg-img');

    function togglePlayPause(event) {
      event.preventDefault(); // Prevent default behavior (e.g., form submission)

      if (footerBgImg.style.animationPlayState === 'paused') {
        footerBgImg.style.animationPlayState = 'running';
        pauseIcon.style.display = 'inline';
        playIcon.style.display = 'none';
        controlButton.setAttribute('aria-label', 'Pause');
      } else {
        footerBgImg.style.animationPlayState = 'paused';
        pauseIcon.style.display = 'none';
        playIcon.style.display = 'inline';
        controlButton.setAttribute('aria-label', 'Play');
      }
    }

    controlButton.addEventListener('click', togglePlayPause);

    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      controlButton.click();
    }
  }
}

export default FooterAnimation;
